/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";
import { toastError } from "../../../utils/sysToast";
import { payBillPrint, postpaidBillPrint } from "../../../utils/printFroms";
import { ExportSheet } from "react-xlsx-sheet";
import XLSX from "xlsx";

class UnitBillsDashboard extends Component {
  state = {
    payMethod: "",
    discountType: "",
    discountAmount: "",

    allUnits: [],
    allPayMethods: [],
    allCompounds: [],
    allServices: [],
    allDiscountTypes: [
      { label: "None", value: "" },
      { label: "Amount", value: "Amount" },
      { label: "Percentage", value: "Percentage" },
    ],
    isPaidOptions: [
      { label: "Unpaid", value: "N" },
      { label: "Paid", value: "Y" },
    ],

    // filters
    filterDates: "",
    filterCompound: "",
    filterUnit: "",
    filterIsPaid: "",
    filterMinDueAmount: "",
    filterService: "",

    xlsxHeaders: [],
    tableData: [],
    totalDue: 0,
    totalPaid: 0,
    unpaidCount: 0,

    inModalModePay: false,
    selectedBill: null,
  };

  componentDidMount() {
    this.getAllUnits();
    this.getAllPayMethods();
    this.getAllCompounds();
    this.getAllServices();
  }

  getAllUnits() {
    post("/api/data/GetAllUnits", null, this.props.updateIsLoading).then(
      (apiResponse) => { this.setState({ allUnits: apiResponse.data.respData.data }); }
    );
  }

  getAllCompounds() {
    post("/api/data/GetAllCompoundsDropdown", null, this.props.updateIsLoading).then(
      (apiResponse) => { this.setState({ allCompounds: apiResponse.data.respData.data }); }
    );
  }

  getAllPayMethods() {
    post("/api/data/GetAllPayMethod", null, this.props.updateIsLoading).then(
      (apiResponse) => { this.setState({ allPayMethods: apiResponse.data.respData.data }); }
    );
  }

  getAllServices() {
    post("/api/data/GetAllServices", null, this.props.updateIsLoading).then(
      (apiResponse) => { this.setState({ allServices: apiResponse.data.respData.data }); }
    );
  }

  getData() {
    const { filterDates, filterCompound, filterUnit, filterIsPaid, filterMinDueAmount, filterService } = this.state;

    if (!filterDates || !filterDates[0] || !filterDates[1]) {
      toastError("Please select Date From and Date To");
      return;
    }

    post(
      "/api/data/GetUnitBillsDashboard",
      {
        dateFrom: filterDates[0],
        dateTo: filterDates[1],
        unitId: filterUnit || null,
        compoundId: filterCompound || null,
        isPaid: filterIsPaid || null,
        minDueAmount: filterMinDueAmount ? parseFloat(filterMinDueAmount) : null,
        serviceId: filterService || null,
      },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        const { bills, totalDue, totalPaid, unpaidCount } = apiResponse.data.respData;
        this.setState({ tableData: bills, totalDue, totalPaid, unpaidCount });
        this.buildExportHeaders(bills);
      }
    });
  }

  buildExportHeaders(rows) {
    if (!rows || rows.length === 0) return;
    let xlsxHeaders = [];
    for (var property in rows[0]) {
      if (rows[0].hasOwnProperty(property)) {
        xlsxHeaders.push({ title: property, dataIndex: property });
      }
    }
    this.setState({ xlsxHeaders });
  }

  // Unpaid bills only; the button is hidden otherwise and the server checks again.
  handleDelete(row) {
    const { t } = this.props;

    confirmAlert({
      title: t("dialog.deleteTitle"),
      message: `${t("dialog.deleteConfirm")} (${t("col.seqNo")}: ${row.SEQ_NO || row.ID}, ${t("col.dueAmount")}: ${(row.DUE_AMOUNT || 0).toLocaleString()})`,
      buttons: [
        {
          label: t("btn.yes"),
          onClick: () => {
            post(
              "/api/data/DeleteServiceBill",
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              if (apiResponse && apiResponse.data.respCode === 0) this.getData();
            });
          },
        },
        { label: t("btn.cancel"), onClick: () => null },
      ],
    });
  }

  handlePrint(row) {
    postpaidBillPrint(
      row.ID,
      row.UNIT_NAME,
      row.OWNER_NAME,
      row.SERVICE_NAME,
      row.DUE_DATE,
      row.DUE_AMOUNT,
      row.NOTES || "",
      row.SYS_USERNAME || "",
      row.IS_PAID === "Y",
      row.PAY_DATE || "",
      row.SEQ_NO || "",
      row.COMPOUND_NAME_EN || "",
      row.COMPOUND_NAME_AR || ""
    );
  }

  openPayModal(billRow) {
    this.setState({
      inModalModePay: true,
      selectedBill: billRow,
      payMethod: "",
      discountType: "",
      discountAmount: "",
    });
  }

  closePayModal() {
    this.setState({ inModalModePay: false, selectedBill: null, payMethod: "", discountType: "", discountAmount: "" });
    this.getData();
  }

  netAmount() {
    const { selectedBill, discountType, discountAmount } = this.state;
    if (!selectedBill) return 0;
    const due = selectedBill.DUE_AMOUNT;
    if (discountType && discountAmount) {
      if (discountType === "Amount") return due - parseFloat(discountAmount);
      if (discountType === "Percentage") return due - (due * parseFloat(discountAmount)) / 100;
    }
    return due;
  }

  doPayBill() {
    const { selectedBill, payMethod, discountType, discountAmount } = this.state;
    if (discountType && discountAmount) {
      const amount = parseFloat(discountAmount);
      const total = selectedBill.DUE_AMOUNT;
      if (discountType === "Amount" && amount > total) {
        toastError(this.props.t("validation.discountExceedsTotal"));
        return;
      }
      if (discountType === "Percentage" && amount > 100) {
        toastError(this.props.t("validation.discountExceeds100"));
        return;
      }
    }
    post(
      "/api/data/PayUnitBillsCash",
      {
        bills: [selectedBill.ID],
        discountType: discountType || null,
        discountAmount: discountAmount || null,
        payMethod,
      },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closePayModal();
        payBillPrint(
          apiResponse.data.respData.paidBills,
          apiResponse.data.respData.totalAmount,
          apiResponse.data.respData.username,
          apiResponse.data.respData.discountType,
          apiResponse.data.respData.discountAmount,
          apiResponse.data.respData.paidAmount,
          apiResponse.data.respData.paymentSeqNo || "",
          apiResponse.data.respData.compoundNameEn || "",
          apiResponse.data.respData.compoundNameAr || ""
        );
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      { id: 1, field: "ID", label: t("col.id"), width: "70px" },
      { id: 12, field: "SEQ_NO", label: t("col.seqNo"), width: "110px" },
      { id: 13, field: "COMPOUND_NAME_EN", label: t("col.compound") },
      { id: 2, field: "UNIT_NAME", label: t("col.unitName") },
      { id: 3, field: "OWNER_NAME", label: t("col.ownerName") },
      { id: 4, field: "SERVICE_NAME", label: t("col.serviceName") },
      { id: 5, field: "DUE_DATE", label: t("col.dueDate") },
      { id: 6, field: "DUE_AMOUNT", label: t("col.dueAmount") },
      {
        id: 7,
        field: "IS_PAID",
        label: t("col.paid"),
        cellRenderer: ({ data }) =>
          data.IS_PAID === "Y" ? (
            <span style={{ color: "white", backgroundColor: "#28A745", borderRadius: "3px", padding: "2px 6px" }}>
              <b>{t("btn.yes")}</b>
            </span>
          ) : (
            <span style={{ color: "white", backgroundColor: "#DC3545", borderRadius: "3px", padding: "2px 6px" }}>
              <b>{t("btn.no")}</b>
            </span>
          ),
      },
      { id: 8, field: "PAY_DATE", label: t("col.payDate") },
      { id: 9, field: "NOTES", label: t("col.notes") },
      { id: 10, field: "SYS_USERNAME", label: t("col.username") },
      {
        id: 11,
        label: t("col.actions"),
        field: "SYS_ACTIONS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => (
          <div id="outer">
            {data.IS_PAID === "N" && sysJwt.isAuthorized(["CB34"]) && (
              <div className="inner" title={t("btn.payBill")}>
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => this.openPayModal(data)}
                >
                  <i className="fa fa-money" />
                </button>
              </div>
            )}
            <div className="inner" title={t("btn.print")}>
              <button
                className="dropdown-item btn-popup-menu"
                disabled={this.props.isLoading}
                onClick={() => this.handlePrint(data)}
              >
                <i className="fa fa-print" />
              </button>
            </div>
            {data.IS_PAID === "N" && sysJwt.isAuthorized(["CB9F"]) && (
              <div className="inner" title={t("btn.delete")}>
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => this.handleDelete(data)}
                >
                  <i className="fa fa-trash" />
                </button>
              </div>
            )}
          </div>
        ),
      },
    ];
  }

  render() {
    const { t } = this.props;
    const { totalDue, totalPaid, unpaidCount, selectedBill } = this.state;
    const hasResults = this.state.tableData.length > 0;

    return (
      <div className="bms-content-component fade-in">
        <div className="row align-items-center">
          <div className="col">
            <h4>{t("pages.unitBillsDashboard")}</h4>
          </div>
        </div>

        {/* Filter bar */}
        <div className="page-filter-bar">
          <span className="filter-label">
            {t("filter.dateFrom")} / {t("filter.dateTo")}
            <span style={{ color: "#DC3545" }}> *</span>:
          </span>
          <Calendar
            selectionMode="range"
            showIcon
            value={this.state.filterDates}
            onChange={(e) => this.setState({ filterDates: e.value })}
            placeholder={`${t("filter.dateFrom")} - ${t("filter.dateTo")}`}
          />

          <span className="filter-label">{t("filter.compound")}:</span>
          <Dropdown
            value={this.state.filterCompound}
            options={this.state.allCompounds}
            showClear filter
            onChange={(e) => this.setState({ filterCompound: e.value })}
            placeholder={t("filter.all")}
          />

          <span className="filter-label">{t("filter.unit")}:</span>
          <Dropdown
            value={this.state.filterUnit}
            options={this.state.allUnits}
            showClear filter
            onChange={(e) => this.setState({ filterUnit: e.value })}
            placeholder={t("filter.all")}
          />

          <span className="filter-label">{t("filter.isPaid")}:</span>
          <Dropdown
            value={this.state.filterIsPaid}
            options={this.state.isPaidOptions}
            showClear
            onChange={(e) => this.setState({ filterIsPaid: e.value })}
            placeholder={t("filter.all")}
          />

          <span className="filter-label">{t("filter.service")}:</span>
          <Dropdown
            value={this.state.filterService}
            options={this.state.allServices}
            showClear filter
            onChange={(e) => this.setState({ filterService: e.value })}
            placeholder={t("filter.all")}
          />

          <span className="filter-label">{t("filter.minDueAmount")}:</span>
          <div style={{ display: "inline-block", width: "100px", flexShrink: 0 }}>
            <InputText
              value={this.state.filterMinDueAmount}
              onChange={(e) => this.setState({ filterMinDueAmount: e.target.value })}
              placeholder="0"
              style={{ width: "100%" }}
              keyfilter="pnum"
            />
          </div>

          <Button
            label={t("btn.search")}
            icon="fa fa-search"
            className="p-button-rounded p-button-secondary"
            disabled={this.props.isLoading}
            onClick={() => this.getData()}
          />

          {hasResults && (
            <ExportSheet
              header={this.state.xlsxHeaders}
              dataSource={this.state.tableData}
              fileName="UnitBillsExport"
              isRequiredNameDate={false}
              xlsx={XLSX}
            >
              <Button
                className="p-button-rounded p-button-success"
                label={t("btn.exportExcel")}
                icon="fa fa-file-excel-o"
              />
            </ExportSheet>
          )}
        </div>
        <hr />

        {/* Summary cards */}
        {hasResults && (
          <div style={{ display: "flex", gap: "10px", marginBottom: "12px" }}>
            {[
              { bg: "#DC3545", label: t("col.totalDue"), value: totalDue.toLocaleString(), sub: `${unpaidCount} ${t("col.unpaidBills")}` },
              { bg: "#28A745", label: t("col.totalPaid"), value: totalPaid.toLocaleString(), sub: null },
              { bg: "#17A2B8", label: t("col.totalBills"), value: this.state.tableData.length, sub: null },
            ].map((card, i) => (
              <div key={i} style={{ background: card.bg, color: "white", borderRadius: "6px", padding: "8px 16px", textAlign: "center", flex: "1 1 0" }}>
                <div style={{ fontSize: "11px", opacity: 0.9 }}>{card.label}</div>
                <div style={{ fontSize: "16px", fontWeight: "bold" }}>{card.value}</div>
                {card.sub && <div style={{ fontSize: "10px", opacity: 0.8 }}>{card.sub}</div>}
              </div>
            ))}
          </div>
        )}

        {/* Pay dialog — per record */}
        <Dialog
          visible={this.state.inModalModePay}
          style={{ width: "45vw" }}
          onHide={() => this.closePayModal()}
          dismissableMask={true}
          closable={false}
          header={<h5 className="modal-header">{t("btn.payBill")}</h5>}
          footer={
            <div>
              <Button
                label={t("btn.save")}
                icon="fa fa-check"
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doPayBill()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closePayModal()}
              />
            </div>
          }
        >
          {selectedBill && (
            <>
              {/* Bill info */}
              <div style={{ background: "#f8f9fa", borderRadius: "6px", padding: "12px 16px", marginBottom: "16px", border: "1px solid #dee2e6" }}>
                <div className="row" style={{ marginBottom: "6px" }}>
                  <div className="col-4" style={{ fontWeight: "bold", color: "#555", fontSize: "12px" }}>{t("col.unitName")}</div>
                  <div className="col-8" style={{ color: "#222" }}>{selectedBill.UNIT_NAME}</div>
                </div>
                <div className="row" style={{ marginBottom: "6px" }}>
                  <div className="col-4" style={{ fontWeight: "bold", color: "#555", fontSize: "12px" }}>{t("col.ownerName")}</div>
                  <div className="col-8" style={{ color: "#222" }}>{selectedBill.OWNER_NAME}</div>
                </div>
                <div className="row" style={{ marginBottom: "6px" }}>
                  <div className="col-4" style={{ fontWeight: "bold", color: "#555", fontSize: "12px" }}>{t("col.serviceName")}</div>
                  <div className="col-8" style={{ color: "#222" }}>{selectedBill.SERVICE_NAME}</div>
                </div>
                <div className="row" style={{ marginBottom: "6px" }}>
                  <div className="col-4" style={{ fontWeight: "bold", color: "#555", fontSize: "12px" }}>{t("col.dueDate")}</div>
                  <div className="col-8" style={{ color: "#222" }}>{selectedBill.DUE_DATE}</div>
                </div>
                <div className="row" style={{ marginBottom: "6px" }}>
                  <div className="col-4" style={{ fontWeight: "bold", color: "#555", fontSize: "12px" }}>{t("col.dueAmount")}</div>
                  <div className="col-8" style={{ color: "#DC3545", fontWeight: "bold" }}>{selectedBill.DUE_AMOUNT?.toLocaleString()}</div>
                </div>
                {selectedBill.NOTES && (
                  <div className="row">
                    <div className="col-4" style={{ fontWeight: "bold", color: "#555", fontSize: "12px" }}>{t("col.notes")}</div>
                    <div className="col-8" style={{ color: "#222" }}>{selectedBill.NOTES}</div>
                  </div>
                )}
              </div>

              {/* Payment fields */}
              <div className="row mb-2">
                <div className="col-4" style={{ fontWeight: "bold", color: "#555", fontSize: "13px", paddingTop: "8px" }}>{t("col.payMethod")}</div>
                <div className="col-8">
                  <Dropdown
                    value={this.state.payMethod}
                    options={this.state.allPayMethods}
                    onChange={(e) => this.setState({ payMethod: e.value })}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              {sysJwt.isAuthorized(["CB4F"]) && (
                <>
                  <div className="row mb-2">
                    <div className="col-4" style={{ fontWeight: "bold", color: "#555", fontSize: "13px", paddingTop: "8px" }}>{t("col.discountType")}</div>
                    <div className="col-8">
                      <Dropdown
                        value={this.state.discountType}
                        options={this.state.allDiscountTypes}
                        onChange={(e) => {
                          this.setState({ discountType: e.value });
                             this.setState({ discountAmount: null });
                        }}
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                  {this.state.discountType && (
                    <div className="row mb-2">
                      <div className="col-4" style={{ fontWeight: "bold", color: "#555", fontSize: "13px", paddingTop: "8px" }}>{t("col.discountAmount")}</div>
                      <div className="col-8">
                        <InputText
                          value={this.state.discountAmount || ""}
                          onChange={(e) => {
                            let val = e.target.value;
                            if (val !== "") {
                              const max = this.state.discountType === "Percentage"
                                ? 100
                                : (selectedBill?.DUE_AMOUNT || 0);
                              if (parseFloat(val) > max) val = String(max);
                            }
                            this.setState({ discountAmount: val });
                          }}
                          keyfilter="pnum"
                          style={{ width: "100%" }}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* Totals */}
              <div style={{ borderTop: "1px solid #dee2e6", paddingTop: "10px", marginTop: "8px" }}>
                <div className="row">
                  <div className="col-6" style={{ color: "black" }}>{t("col.totalAmountToPay")}: <b>{selectedBill.DUE_AMOUNT?.toLocaleString()}</b></div>
                  <div className="col-6" style={{ color: "black" }}>{t("col.netAmountToPay")}: <b style={{ color: "#28A745" }}>{this.netAmount().toLocaleString()}</b></div>
                </div>
              </div>
            </>
          )}
        </Dialog>

        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(UnitBillsDashboard);
